// extracted by mini-css-extract-plugin
export default {"emptyMod":"emptyMod--LIFQM","icon":"icon--c0iDT","text":"text--UMiaJ"};